import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { mapPersonaToPickerOption } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.utils';

export const useRecipients = (ids: ID[]) => {
  const { personasDict } = usePersonaCollection();

  return useMemo(
    () =>
      ids
        .map((id) => personasDict[id])
        .filter(Boolean)
        .map(mapPersonaToPickerOption),
    [personasDict, ids]
  );
};
